import React, { useState } from 'react';
import { Link } from 'react-router-dom';



const NoteSidebar = ({ activityTogglePopup, closeSidebar,isEditing }:any) => {

    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>{isEditing ? "Edit Note" : "Add Note"} </h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <div className="row">
                                <div className="col-md-12">
                                <div className="form-wrap">
                                        <label className="col-form-label">
                                            Title <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control"
                                            type='text'
                                        />
                                    </div>
                                    </div>
                                <div className="col-md-12">

                                    <div className="form-wrap">
                                        <label className="col-form-label">
                                            Description <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows={4}
                                            defaultValue={""}
                                            placeholder='Type....'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 d-flex align-items-center">
                                    <div className="radio-wrap">
                                        <label className="col-form-label">Notes Privacy <span className="text-danger">*</span></label>
                                        <div className="d-flex flex-wrap">
                                            <div className="radio-btn">
                                                <input
                                                    type="radio"
                                                    className="status-radio"
                                                    id="active1"
                                                    name="status"
                                                    defaultChecked={true}
                                                />
                                                <label htmlFor="active1">Client Notes</label>
                                            </div>
                                            <div className="radio-btn">
                                                <input
                                                    type="radio"
                                                    className="status-radio"
                                                    id="inactive1"
                                                    name="status"
                                                />
                                                <label htmlFor="inactive1">Internal Notes</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="submit-button text-end">
                            <Link to="#" className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </Link>
                            <Link
                                to="#"
                                className="btn btn-primary"
                                data-bs-target="#create_project"
                            >
                                {isEditing ? "Update" : "Add"}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoteSidebar;
